export default ['Portable', 'Mobile', 'Base'].sort()
